import { inject } from "@angular/core";
import { type CanActivateFn, type UrlTree, Router, type Routes } from "@angular/router";
import { AuthService, LOGIN_ROUTE_POLICY, businessOwnerGuard } from "@my-sport-app/domain";

/**
 * Root redirect: authenticated users → dashboard, guests → login.
 */
const rootRedirectGuard: CanActivateFn = (): UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const { loginRoute, businessOwnerRoute } = inject(LOGIN_ROUTE_POLICY);

  return authService.isAuthenticated()
    ? router.parseUrl(businessOwnerRoute)
    : router.parseUrl(loginRoute);
};

export const routes: Routes = [
    {
        path: '',
        canActivate: [rootRedirectGuard],
        children: [],
    },
    {
        path: 'auth/business-owner',
        loadComponent: () =>
            import('./features/business-owner-auth/business-owner-auth.component').then(
                (m) => m.BusinessOwnerAuthComponent
            ),
    },
    {
        path: 'auth/business-owner/verify',
        loadComponent: () =>
            import('./features/business-owner-verify/business-owner-verify.component').then(
                (m) => m.BusinessOwnerVerifyComponent
            ),
    },
    {
        path: 'auth/forgot-password',
        loadComponent: () =>
            import('@my-sport-app/cdk').then((m) => m.BoAuthForgotPasswordComponent),
        data: { loginRoute: '/auth/business-owner' },
    },
    {
        path: 'business-owner-dashboard',
        canActivate: [businessOwnerGuard],
        loadComponent: () => import('./layouts/business-owner-layout/business-owner-layout.component').then(m => m.BusinessOwnerLayoutComponent),
        children: [
            {
                path: '',
                redirectTo: 'calendario',
                pathMatch: 'full',
            },
            {
                path: 'calendario',
                loadComponent: () => import('./features/sports-center/sports-center-dashboard.component').then(m => m.SportsCenterDashboardComponent),
            },
            {
                path: 'mis-canchas',
                loadComponent: () => import('./features/mis-canchas/mis-canchas.component').then(m => m.MisCanchasComponent),
            },
        ],
    },
    {
        // Catch /auth/verify?token=... from email links (same path as player app)
        path: 'auth/verify',
        loadComponent: () =>
            import('./features/business-owner-verify/business-owner-verify.component').then(
                (m) => m.BusinessOwnerVerifyComponent
            ),
    },
    {
        path: '**',
        redirectTo: 'auth/business-owner',
    }
];
